export function listingUsd(listing, rates, now = Date.now()) {
  const quote = rates?.ok && rates.quotes?.[listing?.currency === 'WETH' ? 'ETH' : listing?.currency];
  const age = now - Date.parse(quote?.observedAt);
  if (!quote || !(quote.usd > 0) || !Number.isFinite(age) || age < -60000 || age > 180000 || !(listing?.price > 0)) return null;
  const value = listing.price * quote.usd;
  return Number.isFinite(value) ? value : null;
}
export const usdText = value => value === null ? 'USD estimate unavailable' : `≈ ${new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value)} USD`;
export function compareListings(a, b, rates, direction = 'asc', now = Date.now()) {
  const aUsd = listingUsd(a, rates, now), bUsd = listingUsd(b, rates, now);
  // Unconvertible asks stay after comparable asks in either direction. Never compare raw BTC to ETH.
  if (aUsd !== null && bUsd !== null) return (direction === 'desc' ? bUsd - aUsd : aUsd - bUsd);
  if ((aUsd === null) !== (bUsd === null)) return aUsd === null ? 1 : -1;
  return String(a.currency).localeCompare(String(b.currency)) || (direction === 'desc' ? b.price - a.price : a.price - b.price) || String(a.id).localeCompare(String(b.id));
}
export function cheapestListing(listings = [], rates, now = Date.now()) {
  return [...listings].sort((a, b) => compareListings(a, b, rates, 'asc', now))[0] || null;
}
export function sortCards(ids, sort, listings = {}, rates, now = Date.now()) {
  if (!['price-asc', 'price-desc'].includes(sort)) return [...ids].sort((a, b) => sort === 'desc' ? b - a : a - b);
  const best = Object.fromEntries(ids.map(id => [id, cheapestListing(listings[id], rates, now)]));
  return [...ids].sort((a, b) => {
    if (!best[a] || !best[b]) return best[a] ? -1 : best[b] ? 1 : a - b;
    return compareListings(best[a], best[b], rates, sort === 'price-desc' ? 'desc' : 'asc', now) || a - b;
  });
}
